// @lib-export
var TypeBadgeData;
(function (TypeBadgeData) {
    TypeBadgeData["ANONYMOUS"] = "anonymous";
    TypeBadgeData["BOT"] = "bot";
    TypeBadgeData["CUSTOMER"] = "customer";
    TypeBadgeData["ORGANIZATION"] = "organization";
    TypeBadgeData["TEAM"] = "team";
    TypeBadgeData["USER"] = "user";
})(TypeBadgeData || (TypeBadgeData = {}));

export { TypeBadgeData };
//# sourceMappingURL=type-badge-data.js.map
